import * as React from 'react'

function StarIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={41} height={40} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.142 5.865c1.437-3.384 6.233-3.384 7.67 0l2.596 6.11 6.414.537c3.629.304 5.149 4.79 2.452 7.238l-4.905 4.452 1.606 7.393c.811 3.736-3.416 6.5-6.513 4.261l-5.485-3.966-5.485 3.966c-3.098 2.24-7.324-.525-6.513-4.26l1.605-7.394L5.68 19.75c-2.696-2.448-1.176-6.934 2.453-7.238l6.414-.537 2.596-6.11zm4.602 1.303a.833.833 0 00-1.534 0l-2.793 6.573a2.5 2.5 0 01-2.092 1.514l-6.915.58a.833.833 0 00-.49 1.447l5.261 4.775a2.5 2.5 0 01.763 2.382l-1.708 7.864c-.162.747.683 1.3 1.303.852l5.973-4.32a2.5 2.5 0 012.93 0l5.973 4.32c.62.448 1.465-.105 1.303-.852l-1.708-7.864a2.5 2.5 0 01.763-2.382l5.261-4.775a.833.833 0 00-.49-1.448l-6.915-.579a2.5 2.5 0 01-2.093-1.514l-2.792-6.573z'
        fill='#636366'
      />
    </svg>
  )
}

export default StarIcon
